import { truncateDecimals } from './formatters';

export const formatUsd = (value: string | number, options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options,
  }).format(Number(value));
};

export const formatPercent = (value: string | number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(value));
};

export const formatNumberGroupThousands = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    useGrouping: true,
  }).format(Number(value));
};

export const formatAmountDisplay = (amountProps: number) => {
  const amount = Number(truncateDecimals(amountProps, 2));

  if (amount < 1000) {
    return amount.toString();
  }

  const suffixes = ['', 'K', 'M', 'B'];
  const suffixIndex = Math.floor(Math.log10(amount) / 3);

  if (suffixIndex === 0) {
    return amount.toString();
  } else if (suffixIndex === 1) {
    let fractionDigits = 2;

    if (amount >= 1e4 && amount < 1e5) {
      fractionDigits = 1;
    } else if (amount >= 1e5) {
      fractionDigits = 0;
    }

    const scaledAmount = amount / Math.pow(1000, suffixIndex);
    const formattedAmount = scaledAmount.toLocaleString('en-US', {
      maximumFractionDigits: fractionDigits,
    });
    return `${formattedAmount}${suffixes[suffixIndex]}`;
  } else {
    let fractionDigits = 2;

    if (amount >= 1e6 && amount < 1e7) {
      fractionDigits = 2;
    } else if (amount >= 1e7 && amount < 1e8) {
      fractionDigits = 1;
    } else if (amount >= 1e8) {
      fractionDigits = 0;
    }

    const scaledAmount = amount / Math.pow(1000, suffixIndex);
    const formattedAmount = scaledAmount.toLocaleString('en-US', {
      maximumFractionDigits: fractionDigits,
    });

    return `${formattedAmount}${suffixes[suffixIndex]}`;
  }
};

export const getMinValueWithMaxDecimals = (maxDecimals = 0) => {
  const decimalString = '0.' + '0'.repeat(maxDecimals - 1) + '1';

  const minValueWithMaxDecimals = Number(decimalString);

  return { maxDecimals, minValueWithMaxDecimals };
};
